import * as api from '.';
import { MediaType } from '../model';
import { JitsiResult } from '../store/reducers/settings';

function callControl(command: string, params: Record<string, string | undefined>) {
  return api.handler('Handlers/CallControlHandler.ashx', {
    command, ...params,
  })
}

export async function dial(device: string, number: string) {
  await callControl('dial', { number, device })
}

export async function hangup(device: string) {
  await callControl('hangup', { device })
}

export async function answer(device: string) {
  await callControl('answer', { device })
}

export async function hold(device: string, callid?: string) {
  await callControl('hold', { number: callid, device })
}

export async function holdMessage(device: string, holdMessage: number) {
  await callControl('hold', { device, holdMessage: holdMessage.toString() })
}

export async function resume(device: string, callid?: string) {
  await callControl('cancelhold', { number: callid, device })
}

// number is call id or extension
export async function pickup(device: string, number: string, autoAnswer?: boolean) {
  await callControl('pickup', { number, device, answer: autoAnswer === undefined ? '1' : autoAnswer ? '1' : '0' })
}

export async function queuePickup(device: string, mediaType: MediaType, callid: string, queue?: string, autoAnswer?: boolean) {

  if (mediaType === 'CALL' || mediaType === 'VM') {
    await callControl('queuepickup', { number: callid, device, queue, answer: autoAnswer === undefined ? '1' : autoAnswer ? '1' : '0' })
  }
  else {
    await callControl('queuepickup', { number: callid, device, queue, answer: autoAnswer === undefined ? '1' : autoAnswer ? '1' : '0' })
  }
}

export async function queuehold(device: string, queue: string, callId: string, timeOut?: string) {
  await callControl('queuehold', {
    number: queue,
    device,
    callId,
    recall: timeOut,
  })
}

export async function queueResume(device: string, callIds: string[]) {
  await callControl('queueresume', {
    data: JSON.stringify(callIds),
    device,
  })
}

//need to check this one server side
//timeout is in seconds
//looks like there is a callid too
export async function holdFor(device: string, extension: string, callId: string, timeOut?: string) {
  await callControl('holdfor', {
    number: extension,
    callId,
    device,
    recall: timeOut,
  })
}

export async function blindTransfer(device: string, number: string) {
  await callControl('blindtransfer', { number, device })
}

export async function superTransfer(device: string, number: string) {
  await callControl('supertransfer', { number, device })
}

export async function cancelTransfer(device: string) {
  await callControl('canceltransfer', { device })
}

export async function completeTransfer(device: string) {
  await callControl('completeTransfer', { device })
}

export async function intrude(device: string, number: string) {
  await callControl('intrude', { device, number })
}

export async function monitor(device: string, number: string) {
  await callControl('monitor', { device, number })
}

export async function sendToMobile(device: string) {
  await callControl('sendToMobile', { device })
}

export async function sendToAssociate(device: string) {
  await callControl('sendtoassociate', { device })
}

export async function sendToVoicemail(device: string, mailbox: string, callId: string, playGreeting: boolean, userDeliver: boolean) {
  await callControl('sendtovoicemail', { device, mailbox, number: callId, playgreetings: playGreeting ? 'true' : 'false', action: userDeliver ? 'true' : 'false' })
}

export async function monitorVoicemail(device: string, vmPort: string) {
  await callControl('monitorvoicemail', { device, number: vmPort })
}

export async function retrieveVoicemail(device: string, callId: string) {
  await callControl('retrievevoicemail', { device, number: callId })
}

export async function startRecording(device: string, mailbox: string) {
  await callControl('startrecord', { device, number: mailbox })
}

export async function stopRecording(device: string, mailbox: string, voicemailPort: string) {
  await callControl('stoprecord', { device, number: mailbox, vmport: voicemailPort })
}

export async function suppressRecording(device: string, voicemailPort: string, callId: string) {
  await callControl('suppressrecord', { device, number: callId, vmport: voicemailPort })
}

export async function resumeRecording(device: string, callId: string) {
  await callControl('resumerecord', { device, number: callId })
}

export async function playCallbackKeyPress(device: string, vmPort: string) {
  await doDeviceKeyPress('vm-play', device, vmPort)
}

export async function acceptCallbackKeyPress(device: string, vmPort: string) {
  await doDeviceKeyPress('vm-accept', device, vmPort)
}


export async function deleteCallbackKeyPress(device: string, vmPort: string) {
  await doDeviceKeyPress('vm-delete', device, vmPort)
}

export async function deleteCallback(device: string, callId: string) {
  await callControl('vm-delete', { device, callId })
}

async function doDeviceKeyPress(command: string, device: string, vmPort: string) {
  await callControl(command, { device, number: vmPort })
}

//yyyy-MM-dd HH:mm:ss
export async function resetCallback(callId: string, date: string) {
  await callControl('vm-reset', { callId, date })
}

export async function dialConferencePhone(device: string, number: string) {
  await callControl('dialconferencephone', { device, number })
}

export const ConferenceResponseAccept = 1
export const ConferenceResponseReject = 0
export async function conferenceResponse(device: string, number: 0 | 1) {
  await callControl('conferenceacceptreject', { device, number: number.toString() })
}

export async function createJitsiCallRequest(ids: string[]) {
  const command = 'jitsi-now-request'
  const response = await callControl(command, { data: JSON.stringify(ids) })
  return response.substr(command.length + 1)
}

export async function createJitsiCallResponse(jitsiId: string, extension: string, response: JitsiResult) {
  callControl('jitsi-now-response', { number: jitsiId, data: extension, answer: response === JitsiResult.Accept ? "1" : "0" })
}

export async function changePriority(media: string[]) {
  await callControl('priority', { data: JSON.stringify(media) })
}
